import { IDropdownItem, IDropdownListSearch } from "../../types/dropdownInterface";
import { UserDropdown, UserDropdownActionType } from "../actionTypes/userDropdownActionTypes";

export const getUserListDropdown = (payload: IDropdownListSearch): UserDropdownActionType => ({
  type: UserDropdown.GET_USER_DROPDOWN_LIST,
  payload,
});

export const setUserListDropdown = (payload: Array<IDropdownItem>): UserDropdownActionType => ({
  type: UserDropdown.SET_USER_DROPDOWN_LIST,
  payload,
});
